import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { favoritesAPI } from '../../services/api';
import PostCard from '../../components/PostCard/PostCard';
import { FiBookmark, FiLoader } from 'react-icons/fi';
import './Favorites.css';

const Favorites = () => {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await favoritesAPI.getAll();
      setFavorites(response.data.favorites);
    } catch (err) {
      console.error('Error loading favorites:', err);
      setError('Error al cargar tus favoritos');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFavorite = async (postId) => {
    try {
      await favoritesAPI.remove(postId);
      setFavorites(favorites.filter(fav => fav.id !== postId));
    } catch (err) {
      console.error('Error removing favorite:', err);
    }
  };

  if (loading) {
    return (
      <div className="favorites-container">
        <div className="favorites-loading">
          <FiLoader className="spinning" size={32} />
          <p>Cargando tus favoritos...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="favorites-container">
        <div className="favorites-error">
          <p>{error}</p>
          <button onClick={loadFavorites} className="btn-retry">
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="favorites-container">
      <div className="favorites-header">
        <div className="favorites-title">
          <FiBookmark size={28} />
          <h1>Mis Favoritos</h1>
        </div>
        <p className="favorites-count">
          {favorites.length === 0
            ? 'No tienes publicaciones guardadas'
            : `${favorites.length} ${favorites.length === 1 ? 'publicación guardada' : 'publicaciones guardadas'}`}
        </p>
      </div>

      {favorites.length === 0 ? (
        <div className="favorites-empty">
          <FiBookmark size={64} />
          <h2>No tienes favoritos aún</h2>
          <p>
            Guarda publicaciones interesantes para leerlas más tarde.
            <br />
            Solo tienes que hacer clic en el ícono de guardar en cualquier publicación.
          </p>
        </div>
      ) : (
        <div className="favorites-grid">
          {favorites.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              onRemoveFavorite={() => handleRemoveFavorite(post.id)}
              isFavorited={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Favorites;
